import { Table } from 'antd'
import { getColumnsArticleItems } from './columsArticleItems'
import { ArticleType } from 'src/pages/budget/types'

type PropsType = {
  article: ArticleType
}

export const ArticleItems = ({ article }: PropsType) => {
  const { items = [] } = article

  return (
    <Table
      dataSource={items}
      pagination={false}
      columns={getColumnsArticleItems(article)}
      rowKey={(record) => record.id}
      rowClassName={(_, index) =>
        `ant_table_row_height ${index % 2 ? 'even-row' : 'odd-row'}`
      }
    />
  )
}
